export enum ChannelTypes {
  text = 'text',
  sharedWithMe = 'sharedWithMe',
  favorites = 'favorites',
  recents = 'recents',
  popular = 'popular',
  recommendations = 'recommendations',
  starters = 'starters',
}
